interface LinkedOperationsAlertProps {
  amount: number;
  hours: number;
  onAmountChange: (amount: number) => void;
  onHoursChange: (hours: number) => void;
}

function LinkedOperationsAlert({ 
  amount, 
  hours, 
  onAmountChange, 
  onHoursChange 
}: LinkedOperationsAlertProps): JSX.Element {
  return (
    <div className="App-linked-ops-content">
      <div className="App-linked-ops-label">Transfers above</div>
      <div className="App-linked-ops-input-group">
        <input
          type="number"
          min={0}
          step={100}
          value={amount}
          onChange={(e) => {
            const next = Number(e.target.value || 0);
            onAmountChange(next);
          }}
          className="App-linked-ops-input"
          onClick={(e) => e.stopPropagation()}
        />
        <span className="App-linked-ops-unit">EUR</span>
      </div>
      <div className="App-linked-ops-label">for linked operations in</div>
      <div className="App-linked-ops-input-group">
        <input
          type="number"
          min={1}
          step={1}
          value={hours}
          onChange={(e) => {
            const next = Number(e.target.value || 1);
            onHoursChange(next);
          }}
          className="App-linked-ops-input"
          onClick={(e) => e.stopPropagation()}
        />
        <span className="App-linked-ops-unit">hours</span>
      </div>
    </div>
  );
}

export default LinkedOperationsAlert;

